<h4 class="fs-6">
  {{ 'label.test-pre-check-question' | translate }}
</h4>

<app-form-field-select
  [field]="testForm"
  [options]="testFormOptions"
  [label]="'label.dropdown-select' | translate"
></app-form-field-select>
